import { Text, Button } from '@leroy-merlin-br/backyard-react'
import { Fragment } from 'react'

import * as S from './styled'

type Props = {
  shouldShowAssistedSaleButton: boolean
  shouldShowEcommerceButton: boolean
  shouldShowPickupInStoreButton: boolean
  isSingleGrid: boolean
  addDeliveryProductToCart: () => void
  showStockInfo: () => void
}

const ButtonsSection: React.FC<Props> = (props: Props) => {
  const {
    shouldShowAssistedSaleButton,
    shouldShowPickupInStoreButton,
    shouldShowEcommerceButton,
    isSingleGrid,
    addDeliveryProductToCart,
    showStockInfo
  } = props

  return (
    <S.Wrapper isSingleGrid={isSingleGrid}>
      {shouldShowEcommerceButton && (
        <S.DeliveryButton>
          <Button onClick={addDeliveryProductToCart} isStretch>
            Comprar e receber
          </Button>
        </S.DeliveryButton>
      )}

      {!isSingleGrid && (
        <S.OptionIcon>
          <S.OptionLabel>
            <Text size="kilo" noMargin color="n700" align="center">
              ou
            </Text>
          </S.OptionLabel>
        </S.OptionIcon>
      )}

      {shouldShowPickupInStoreButton && (
        <S.PickupButton>
          <Button appearance="info" onClick={showStockInfo} isStretch>
            Retirar na loja
          </Button>
        </S.PickupButton>
      )}

      {shouldShowEcommerceButton && (
        <S.DeliveryLink isSingleGrid={isSingleGrid}>
          <Text as="a" size="kilo" noMargin color="p600" isBold>
            Calcule o frete do produto
          </Text>
        </S.DeliveryLink>
      )}

      {shouldShowPickupInStoreButton && (
        <S.PickupLink>
          <Fragment>
            <Text as="a" size="kilo" noMargin color="b700" isBold>
              Confira o estoque das lojas
            </Text>
          </Fragment>
        </S.PickupLink>
      )}
    </S.Wrapper>
  )
}

export default ButtonsSection
